import { BASE_URL } from '../../constants/baseUrl';
import axiosInstance from '../../utils/axiosInstance';

class ParcelWeightService {
  fetchParcelWeights = () => {
    return axiosInstance.get(`${BASE_URL}/v1/lookups/package-weights`);
  };

  addParcelWeight = (parcelWeightFormData) => {
    return axiosInstance.post(
      `${BASE_URL}/v1/lookups/package-weights`,
      parcelWeightFormData,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    );
  };

  updateParcelWeight = (id, queryParams) => {
    const params = new URLSearchParams(queryParams);
    const url = `${BASE_URL}/v1/lookups/package-weights/${id}?${params.toString()}`;
    return axiosInstance.put(url);
  };

  deleteParcelWeight = (id) => {
    return axiosInstance.delete(
      `${BASE_URL}/v1/lookups/package-weights/${id}`,
    );
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ParcelWeightService();
